import { Module } from 'vuex';

export class AuthState {
  public token: string | null = null;
  public authenticated: boolean = false;
  public fileQueryParams: string | null = null;
}

const authModule: Module<AuthState, any> = {
  namespaced: true,
  state: () => {
    const state = new AuthState();
    state.token = getAuthToken();
    state.authenticated = !!state.token;
    state.fileQueryParams = state.token ? getFileParams() : null;
    return state;
  },

  getters: {
    authenticated: state => state.authenticated,
    token: state => state.token,
    fileQueryParams: state => state.fileQueryParams || '',
  },

  mutations: {
    refreshToken: state => {
      const token = getAuthToken();
      state.token = token;
      state.authenticated = !!token;
    },
    updateQueryParams: state => {
      state.fileQueryParams = getFileParams();
    }
  },

  actions: {
    setAuthToken: ({ commit }, token: string) => {
      setAuthToken(token, getExpiresFromJWT(token));
      commit('refreshToken');
    },
    deleteAuthToken: ({ commit }) => {
      setAuthToken('');
      clearQueryParams();
      commit('refreshToken');
    },
    setFileQueryParams: ({ commit }, params: string) => {
      setQueryParams(params);
      commit('updateQueryParams');
    }
  },
};

const getAuthToken = () =>
  (document.cookie.match(/_token=(.*?)(;|$)/) || [])[1] || null;

const getExpiresFromJWT = (jwt: string) => {
  try {
    const section = jwt.split('.')[1];
    const obj = JSON.parse(new Buffer(section, 'base64').toString('utf8'));
    return new Date(obj.exp * 1000);
  } catch (error) {
    // console.error(error);
    return new Date(Date.now() + 1 * 60 * 60 * 1000);
  }
};

const setAuthToken = (token: string, expDate?: Date) => {
  const date = expDate || new Date(0);
  document.cookie = `_token=${token};expires=${date.toUTCString()};path=/`;
};

const clearQueryParams = () => localStorage.removeItem('FILE_QUERY_PARAMS');

const setQueryParams = (params: string) => localStorage.setItem('FILE_QUERY_PARAMS', params);

const getFileParams = () => localStorage.getItem('FILE_QUERY_PARAMS');

export default authModule;
